<template>
  <FormItemSkuList
    ref="formItemSkuListRef"
    :specifications="specifications"
    :tableCols="skuExtendTableCols"
    v-model="curSkulist"
    :showImgCol="false"
    @change="skuListChange"
  >
    <!-- <template slot="productSkuSensitiveAttrReqHeaderSlot" slot-scope="scope">
      <span style="color: red">*</span>敏感属性
      <el-popover placement="bottom" width="300" trigger="hover">
        <el-button slot="reference" type="link">批量设置</el-button>
        <div>
          <SensitiveAttrInput v-model="batchValues.sensitiveAttr" />
          <el-button type="primary" @click="batchSetSensitiveAttr" style="float: right;margin: 10px">确定</el-button>
        </div>
      </el-popover>
    </template> -->
    <template slot="productSkuWeightReqHeaderSlot" slot-scope="scope">
      <span style="color: red">*</span>重量
      <el-popover placement="bottom" width="200" trigger="hover">
        <el-button slot="reference" type="link">批量设置</el-button>
        <div>
          <el-input-digit
            v-model.number="batchValues.productSkuWeightReq.weightValue"
            placeholder="请输入"
            format="#.#"
            style="width: 90px"
          >
            <span>g</span>
          </el-input-digit>
          <el-button type="primary" @click="batchSetVal('productSkuWeightReq')" style="margin-left: 6px">确定</el-button>
        </div>
      </el-popover>
    </template>
    <template slot="productSkuVolumeReqHeaderSlot" slot-scope="scope">
      <span style="color: red">*</span>体积（单位：cm）
      <el-popover placement="bottom" width="200" trigger="hover">
        <el-button slot="reference" type="link">批量设置</el-button>
        <div>
          <VolumeInput v-model="batchValues.productSkuVolumeReq" />
          <el-button type="primary" @click="batchSetVal('productSkuVolumeReq')" style="margin: 10px">确定</el-button>
        </div>
      </el-popover>
    </template>

    <template slot="productSkuSensitiveAttrReqSlot" slot-scope="{ row }">
      <SensitiveAttrInput v-model="row.productSkuWhExtAttr" />
    </template>
    <template slot="productSkuVolumeReqSlot" slot-scope="{ row }">
      <VolumeInput v-model="row.productSkuWhExtAttr.productSkuVolumeReq" />
    </template>
    <template slot="productSkuWeightReqSlot" slot-scope="{ row }">
      <el-input-digit
        v-model.number="row.productSkuWhExtAttr.productSkuWeightReq.weightValue"
        placeholder="请输入"
        format="#.#"
        style="width: 90px"
      >
        <span>g</span>
      </el-input-digit>
    </template>
    <template slot="productSkuNetWeightReqSlot" slot-scope="{ row }">
      <el-input-digit
        v-model.number="row.productSkuWhExtAttr.productSkuNetWeightReq.value"
        placeholder="请输入"
        format="#.#"
        style="width: 90px"
      >
        <span>mg</span>
      </el-input-digit>
    </template>
  </FormItemSkuList>
</template>

<script>
import FormItemSkuList from '../../../FormItemSpecification/FormItemSkuList.vue';
import VolumeInput from './VolumeInput.vue';
import SensitiveAttrInput from './SensitiveAttrInput.vue';
import { isSensitiveOpts, sensitiveTypesOpts } from '../../config';
import { getProductSkuWhExtAttr } from '@/servers/prod/center/temu.js';
import { cloneDeep } from 'lodash';

export default {
  model: {
    prop: 'skuList',
    event: 'change',
  },
  components: {
    FormItemSkuList,
    VolumeInput,
    SensitiveAttrInput
  },
  props: {
    specifications: {
      type: Array,
      default() {
        return [];
      },
    },
    skuList: {
      type: Array,
      default() {
        return [];
      },
    },
    categoryId: [String, Number],
  },
  data() {
    return {
      isSensitiveOpts,
      sensitiveTypesOpts,
      curSkulist: [],
      batchValues: {
        ...getProductSkuWhExtAttr({}),
        sensitiveAttr: {
          productSkuSensitiveAttrReq: {
            isSensitive: 0,
            sensitiveTypes: []
          },
          productSkuSensitiveLimitReq: {
            maxBatteryCapacity: '',
            maxLiquidCapacity: '',
            maxKnifeLength: '',
            knifeTipAngle: { degrees: '' }
          }
        }
      },
      skuExtendTableCols: [
        {
          prop: 'productSkuSensitiveAttrReq',
          attrs: { label: '敏感属性' },
          slot: true,
          // headerSlot: true,
        },
        {
          prop: 'productSkuVolumeReq',
          attrs: { label: '体积（单位：cm）' },
          slot: true,
          headerSlot: true,
        },
        {
          prop: 'productSkuWeightReq',
          attrs: { label: '重量' },
          input: { type: 'number', onlyTable: true },
          slot: true,
          headerSlot: true,
        },
        {
          prop: 'productSkuNetWeightReq',
          attrs: { label: '货品净重',noRequired:true },
          input: { type: 'number', onlyTable: true },
          slot: true,
          // headerSlot: true,
        },
      ],
      isChange: false,
    };
  },
  watch: {
    skuList: {
      handler(v) {
        // if (this.isChange) {
        //   this.isChange = false;
        //   return;
        // }
        this.curSkulist = cloneDeep(v);
      },
      deep: true,
      immediate: true,
    },
    curSkulist: {
      handler(v) {
        // this.isChange = true;
      },
      deep: true,
    },
  },
  methods: {
    skuListChange(v){
        this.$emit('change', cloneDeep(v));
        // this.$emit('change', cloneDeep(this.curSkulist));
        this.$emit('fieldChanged');
    },
    isSensitiveChange(v, row) {
      row.productSkuWhExtAttr.productSkuSensitiveAttrReq.sensitiveTypes = [];
    },
    batchSetVal(prop) {
      const batchList = this.$refs.formItemSkuListRef.getNeedBatchList();
      const targetSkuIds = new Set(batchList.map(item => item._skuid));
      const renderList = cloneDeep(this.$refs.formItemSkuListRef.renderList);
      const newRenderList = renderList.map(item => {
        if (targetSkuIds.has(item._skuid)) {
          item.productSkuWhExtAttr[prop] = cloneDeep(this.batchValues[prop]);
        }
        return item;
      });
      this.$refs.formItemSkuListRef.setRenderList(newRenderList);
      this.$set(this.batchValues, prop, getProductSkuWhExtAttr({})[prop]);
    },
    batchSetSensitiveAttr() {
      const batchList = this.$refs.formItemSkuListRef.getNeedBatchList();
      const targetSkuIds = new Set(batchList.map(item => item._skuid));
      const renderList = cloneDeep(this.$refs.formItemSkuListRef.renderList);
      const newRenderList = renderList.map(item => {
        if (targetSkuIds.has(item._skuid)) {
          item.productSkuWhExtAttr.productSkuSensitiveAttrReq = cloneDeep(this.batchValues.sensitiveAttr.productSkuSensitiveAttrReq);
          item.productSkuWhExtAttr.productSkuSensitiveLimitReq = cloneDeep(this.batchValues.sensitiveAttr.productSkuSensitiveLimitReq);
        }
        return item;
      });
      this.$refs.formItemSkuListRef.setRenderList(newRenderList);
      // 重置批量设置值
      this.batchValues.sensitiveAttr = {
        productSkuSensitiveAttrReq: {
          isSensitive: 0,
          sensitiveTypes: []
        },
        productSkuSensitiveLimitReq: {
          maxBatteryCapacity: '',
          maxLiquidCapacity: '',
          maxKnifeLength: '',
          knifeTipAngle: { degrees: '' }
        }
      };
    },
    validate() {
      let errorMsg = '';
      const findErrRow = this.curSkulist.find(row => {
        const { productSkuWhExtAttr } = row;
        const { productSkuSensitiveAttrReq, productSkuSensitiveLimitReq, productSkuVolumeReq, productSkuWeightReq,productSkuNetWeightReq } =
          productSkuWhExtAttr || {};
        const { isSensitive, sensitiveTypes = [] } = productSkuSensitiveAttrReq || {};
        if (isSensitive === 1) {
          if (!sensitiveTypes.length) {
            errorMsg = '请选择敏感属性';
          } else if ((sensitiveTypes.includes(1) || sensitiveTypes.includes(2)) && !productSkuSensitiveLimitReq?.maxBatteryCapacity) {
            errorMsg = '储电容量不能为空';
          } else if (sensitiveTypes.includes(4) && !productSkuSensitiveLimitReq?.maxLiquidCapacity) {
            errorMsg = '液体容量不能为空';
          } else if (sensitiveTypes.includes(7) && !productSkuSensitiveLimitReq?.maxKnifeLength) {
            errorMsg = '刀具长度不能为空';
          } else if (sensitiveTypes.includes(7) && !productSkuSensitiveLimitReq?.knifeTipAngle?.degrees) {
            errorMsg = '刀尖角度不能为空';
          }
          if (errorMsg) return true;
        }

        const { volumeLen, volumeWidth, volumeHeight } = productSkuVolumeReq || {};
        const weightValue = Number(productSkuWeightReq?.weightValue);
        if (!volumeLen || !volumeWidth || !volumeHeight) {
          errorMsg = '请完善体积';
        } else if(volumeLen < volumeWidth || volumeLen < volumeHeight || volumeWidth < volumeHeight){
          errorMsg = '体积内容必须遵循 最长边 ≥ 次长边 ≥ 最短边原则'
        } else if (!productSkuWeightReq?.weightValue) {
          errorMsg = '请输入重量';
        } else if (isNaN(weightValue)) {
          errorMsg = '重量格式不正确';
        } else if (weightValue < 2) {
          errorMsg = '重量不可小于2g';
        } else if (weightValue > 99999) {
          errorMsg = '重量不可大于99999g';
        }
        return !!errorMsg;
      });
      const requiredArr = ['11915','11843','11844','11994','12011','11918','11995','12009','12013','11920','12010','11921','12014','12001','12002','11846','11906','11907','11909','11910','11911','11912','11914','11872','11873','11860','11876','11958','11968','11881','11879','11882','11883','11969','11908','11913']
      if( requiredArr.includes(this.categoryId +'') && !productSkuNetWeightReq?.value){
         errorMsg = '货品重量必填！';
      }
      if (findErrRow) {
        let skuSvalues = [];
        this.specifications.forEach(s => {
          const value = findErrRow.skuSpecifications.find(skuS => skuS.name === s.name).value;
          skuSvalues.push(value);
        });
        errorMsg = `【 ${skuSvalues.join(' + ')} 】：` + errorMsg;
      }
      return errorMsg;
    },
  },
};
</script>

<style lang="scss">
</style>